import { accessToken } from '@/configuration/tokenHandling/accessToken';
import { AccessToken } from '@/configuration/tokenHandling/tokenSlice';
import {Response} from '@/services/config/types';

// INFO: Server response type for user's preference
export type UserPreferences = {
  created_at: string | null;
  updated_at: string | null;
  safety_notice_hidden_until: string | null;
  terms_accepted: boolean;
  terms_accepted_at: string | null;
  fleet_name: string;
};

export const fetchUserPreferences = async (
    userId: string
): Promise<UserPreferences> => {
  const url = `${import.meta.env.VITE_BASE_BACKEND_URL}/user/preferences/${userId}`;
  const token = accessToken.getAccessToken() as AccessToken;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error(
        `Failed to fetch user preferences: ${response.status} ${response.statusText}`
    );
  }

  const result: Response<UserPreferences> = await response.json();

  if (!result || !result.data) {
    throw new Error('No data returned from the API');
  }

  return result.data;
};

export const updateUserPreferences = async (
    userId: string,
    preferences: Partial<UserPreferences>
): Promise<UserPreferences> => {
  const url = `${import.meta.env.VITE_BASE_BACKEND_URL}/user/preferences/${userId}`;
  const token = accessToken.getAccessToken() as AccessToken;

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(preferences),
  });

  if (!response.ok) {
    throw new Error(
        `Failed to update user preferences: ${response.status} ${response.statusText}`
    );
  }

  const result: Response<UserPreferences> = await response.json();

  if (!result || !result.data) {
    throw new Error('No data returned from the API');
  }

  return result.data;
};
